import type { ReactNode } from "react";

export function wizardPct(step: number, totalSteps: number): number {
  return Math.max(0, Math.min(100, Math.round((step / totalSteps) * 100)));
}

/**
 * Shared progress bar: mono label on the left, optional label/percent on the
 * right, and a thin theme-colored bar. Callers decide the label text (phase
 * name vs "Step X of Y") and the percentage via {@link wizardPct}.
 */
export function ProgressBar({
  pct,
  left,
  right,
  className = "mb-8",
}: {
  pct: number;
  left: ReactNode;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <div className={className}>
      <div className="mb-2 flex items-baseline justify-between gap-3">
        <span className="font-mono text-[12px] uppercase tracking-wider text-ink-subtle">
          {left}
        </span>
        {right != null && (
          <span className="font-mono text-[12px] uppercase tracking-wider text-ink">{right}</span>
        )}
      </div>
      <div className="h-1 w-full overflow-hidden rounded-full bg-border">
        <div
          className="h-full rounded-full bg-theme-accent transition-all duration-200"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
